import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UseHandleBack from "@/hooks/UseHandleBack";
const Navbar = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [activeSubMenu, setActiveSubMenu] = useState(null);

	const mobileMenuOptions = [
		"Home",
		"Products",
		"Trends",
		"Success Stories",
		"Blog",
	];
	const navigate = useNavigate();
	const handleBack = () => {
		navigate(-1); // Go back to previous page
	};

	const handleMenuClick = (option) => {
		const routes = {
			Home: "/",
			Products: "/products",
			Marketplaces: "/marketplaces",
			Trends: "/trends",
			"Success Stories": "/success-stories",
			Blog: "/blog",
		};

		if (option === "Products" || option === "Trends") {
			setActiveSubMenu(activeSubMenu === option ? null : option);
		} else {
			setActiveSubMenu(null);
			navigate(routes[option] || "/");
			setIsOpen(false);
		}
	};
	const getSubMenuItems = (menuItem) => {
		if (menuItem === "Products") {
			return [
				{ name: "All", path: "/products" },
				{ name: "Alibaba", path: "/products/alibaba" },
				{ name: "Aliexpress", path: "/products/aliexpress" },
				{ name: "Amazon", path: "/products/amazon" },
				{ name: "Etsy", path: "/products/etsy" },
				{ name: "Walmart", path: "/products/walmart" },
				{ name: "Jumbo", path: "/products/jumbo" },
				{ name: "Supermarkt", path: "/products/supermarkt" },
			];
		} else if (menuItem === "Trends") {
			return [
				{ name: "All", path: "/trends" },
				{ name: "Facebook", path: "/trends/facebook" },
				{ name: "Google", path: "/trends/google" },
				{ name: "Instagram", path: "/trends/instagram" },
			];
		}
		return [];
	};

	return (
		<>
			{/* Mobile Navbar (Visible on <768px) */}
			<nav className="w-full h-20 flex items-center justify-between px-6 bg-bgPrimary shadow-md lg:hidden relative">
				{isOpen ? (
					<p
						className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34] cursor-pointer"
						onClick={handleBack}
					>
						Back
					</p>
				) : (
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/topnav/logo.svg"
						className="h-7"
						alt="Logo"
					/>
				)}

				<button
					onClick={() => setIsOpen(!isOpen)}
					className="flex items-center px-3 py-2 rounded text-black-500 hover:text-black-400"
				>
					<svg
						className={`fill-current h-5 w-5 ${isOpen ? "hidden" : "block"}`}
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
					</svg>
				</button>

				{isOpen && (
					<div className="relative inline-block">
						<button
							onClick={() => setIsOpen(!isOpen)}
							className="w-[88px] h-[40px] flex items-center justify-center border rounded-[4px] px-2 gap-2"
						>
							<img
								src="/assets/home/topnav/userImage.svg"
								alt="start icon"
								className="w-[32px] h-[32px]"
							/>
							<img
								src="/assets/home/topnav/arrowDownMobile.svg"
								alt="end icon"
								className="w-[32px] h-[32px]"
							/>
						</button>

						<div className="absolute w-[138px] h-auto top-[40px] right-0 bg-[#E8ECEB] border border-gray-200 rounded-[4px] shadow-lg z-50">
							{mobileMenuOptions.map((option, idx) => (
								<div key={idx} className="relative">
									<div
										className="px-4 py-2 text-[12px] text-[#193D34] font-[400] font-montserrat leading-[100%] cursor-pointer hover:bg-[#CFE6A2] flex justify-between items-center"
										onClick={() => handleMenuClick(option)}
									>
										<span>{option}</span>
									</div>

									{/* Submenu to the left */}
									{activeSubMenu === option && (
										<div className="absolute right-full top-0 w-[138px] bg-[#E8ECEB] border border-gray-200 rounded-[4px] shadow-lg z-50">
											{getSubMenuItems(option).map((item, subIdx) => (
												<Link
													key={subIdx}
													to={item.path}
													className="block px-3 py-2 text-[12px] text-[#193D34] font-[400] font-montserrat hover:bg-[#CFE6A2]"
												>
													{item.name}
												</Link>
											))}
										</div>
									)}
								</div>
							))}
						</div>
					</div>
				)}
			</nav>

			{/* Desktop Navbar (Hidden on <768px) */}

			<nav className="w-full hidden lg:flex h-20 items-center justify-center bg-bgPrimary shadow-md">
				<div className="w-full exact-1024:ml-[30px] max-w-[1830px]  flex items-center justify-between px-8">
					<a href="/" className="flex items-center">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/home/topnav/logo.svg"
							className="h-7"
							alt="Logo"
						/>
					</a>

					<div className="flex items-center space-x-4 exact-1024:pl-[20px]">
						<div className="group relative py-6">
							<div className="text-gray-700 hover:text-black flex items-center cursor-pointer">
								<Link to="/products" className="flex items-center">
									Products
									<img
										loading="lazy"
										decoding="async"
										src="/assets/home/topnav/arrowDown.png"
										className="h-4 w-4 ml-1"
										alt="Arrow Icon"
										style={{ width: "5.66px", height: "3.77px" }}
									/>
								</Link>
							</div>

							<div className="absolute hidden group-hover:block w-[138px] bg-bgPrimary shadow-lg rounded-md mt-5 z-50 pointer-events-none group-hover:pointer-events-auto">
								{[
									{ name: "All", path: "/products" },
									{ name: "Alibaba", path: "/products/alibaba" },
									{ name: "Aliexpress", path: "/products/aliexpress" },
									{ name: "Amazon", path: "/products/amazon" },
									{ name: "Etsy", path: "/products/etsy" },
									{ name: "Walmart", path: "/products/walmart" },
									{ name: "Jumbo", path: "/products/jumbo" },
									{ name: "Supermarkt", path: "/products/supermarkt" },
								].map((item, index) => (
									<Link
										key={index}
										to={item.path}
										className="block px-3 py-1 text-sm nav-link-dropdown hover:bg-[#CFE6A2] hover:text-black"
									>
										{item.name}
									</Link>
								))}
							</div>
						</div>

						<div className="group relative py-6">
							<div className="text-gray-700 hover:text-black flex items-center cursor-pointer">
								<Link to="/products" className="flex items-center">
									Trends
									<img
										loading="lazy"
										decoding="async"
										src="/assets/home/topnav/arrowDown.png"
										className="h-4 w-4 ml-1"
										alt="Arrow Icon"
										style={{ width: "5.66px", height: "3.77px" }}
									/>
								</Link>
							</div>

							<div className="absolute hidden group-hover:block w-[138px] bg-bgPrimary shadow-lg rounded-md mt-5 z-50 pointer-events-none group-hover:pointer-events-auto">
								{[
									{ name: "All", path: "/trends" },
									{ name: "Facebook", path: "/trends/facebook" },
									{ name: "Google", path: "/trends/google" },
									{ name: "Instagram", path: "/trends/instagram" },
								].map((item, index) => (
									<Link
										key={index}
										to={item.path}
										className="block px-3 py-1 text-sm nav-link-dropdown hover:bg-[#CFE6A2] hover:text-black"
									>
										{item.name}
									</Link>
								))}
							</div>
						</div>

						<Link
							to="/success-stories"
							className="text-gray-700 hover:text-black exact-1024:whitespace-nowrap"
						>
							Success Stories
						</Link>

						<Link to="/blog" className="text-gray-700 hover:text-black">
							Blog
						</Link>
					</div>

					<div className="flex items-center space-x-4 exact-1024:pl-[10px]">
						<div className="relative flex items-center">
							<input
								type="text"
								placeholder="Search product.."
								className="pl-4 pr-12 w-full h-[40px] border border-gray-300 rounded-lg bg-bgSecondary text-black text-center placeholder:text-center outline-none focus:ring-0 focus:outline-none focus:border-gray-300"
							/>
							<button className="absolute right-0 flex items-center justify-center w-[40px] h-[40px] bg-[#B7D974] rounded-r-lg outline-none focus:ring-0">
								<img
									loading="lazy"
									decoding="async"
									src="/assets/home/topnav/search.png"
									alt="Search"
									className="w-[20px] h-[20px]"
								/>
							</button>
						</div>

						<div className="flex items-center bg-[#DEEEBF] rounded-md px-4 py-2 space-x-2">
							<Link
								to="/login"
								className="px-4 py-2 text-black  focus:outline-none"
							>
								Login
							</Link>
							<Link
								to="/sign-up"
								className="px-4 py-2 bg-[#B7D974] text-black rounded-md hover:bg-[#a4c86a] focus:outline-none exact-1024:whitespace-nowrap"
							>
								Create Account
							</Link>
						</div>
					</div>
				</div>
			</nav>
		</>
	);
};

export default Navbar;
